<template>
    <div class="flex flex-col items-center gap-2">
        <div class="text-white text-lg font-bold">Overlay Character</div>
        <img :src="`/character/${selectedCharacter.filename}`" class="bg-light-gray rounded w-32">
        <div class="text-white">{{ selectedCharacter.name }}</div>
        <donation-button class="mt-4" @click="setIsOpen(true)">Change Character</donation-button>

        <Dialog title="Overlay Character" description="Choose the character who walks across the screen" :isOpen="isOpen" @close="setIsOpen">
            <RadioGroup class="grid grid-cols-2 sm:grid-cols-4 gap-x-2 gap-y-4" v-model="selectedCharacter">
                <RadioGroupOption v-for="character in characters" :key="character.filename" :value="character" v-slot="{ active, checked }" class="space-y-2 group">
                    <div class="rounded-lg relative hover:bg-gradient-to-br hover:from-yellow hover:via-white hover:to-yellow" :class="[
                        active ? 'bg-gradient-to-br from-yellow via-white to-yellow' : 'bg-light-gray',
                        checked ? 'bg-gradient-to-br from-purple to-blue' : 'bg-light-gray'
                    ]">
                        <div :class="checked || active ? 'block' : 'hidden'" class="bg-light-gray absolute inset-1 z-0 rounded group-hover:block"></div>
                        <img :src="`/character/${character.filename}`" class="relative z-10">
                    </div>
                    <RadioGroupLabel as="div" class="text-xs text-center">{{ character.name }}</RadioGroupLabel>
                </RadioGroupOption>
            </RadioGroup>
        </Dialog>
    </div>
</template>

<script setup>
import { onMounted, ref, inject, watch } from 'vue';
import { RadioGroup, RadioGroupOption, RadioGroupLabel } from '@headlessui/vue';
import DonationButton from './ui/Button.vue';
import Dialog from './ui/Dialog.vue';

const characters = ref([]);
const selectedCharacter = inject('character');

onMounted(() => {
    fetch('/characters/dn')
        .then(response => response.json())
        .then(value => {
            characters.value = value;

            if (value.length) {
                selectedCharacter.value = value[0];
            }
        })
})

watch(selectedCharacter, (newValue) => {
    setIsOpen(false);
})

const isOpen = ref(false);
const setIsOpen = (value) => {
    isOpen.value = value
}
</script>